import { Environment } from '@resultsgate-ui/shared'
class EnvironmentImpl implements Environment {
    production = false
    version = 'LOCAL'
    sentryDSN = 'https://7e5c77c49dd84473a5c16e417d49735e@o418115.ingest.sentry.io/5320291'
}

export const environment = new EnvironmentImpl()

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
